module.exports = __webpack_public_path__ + "static/media/custom-report.4cdb5d8a.png";